/* eslint-disable max-len */
import { memo } from 'react';

interface IArrowDownIconProps {
  fill: string;
}

function ArrowDownIcon({ fill }: IArrowDownIconProps) {
  return (
    <svg
      width="26"
      height="15"
      viewBox="0 0 26 15"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.29289 1.29289C1.68342 0.902369 2.31658 0.902369 2.70711 1.29289L13 11.5858L23.2929 1.29289C23.6834 0.902369 24.3166 0.902369 24.7071 1.29289C25.0976 1.68342 25.0976 2.31658 24.7071 2.70711L13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L1.29289 2.70711C0.902369 2.31658 0.902369 1.68342 1.29289 1.29289Z"
        fill={fill}
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default memo(ArrowDownIcon);
